import React, { createContext, useContext, useState, useCallback } from 'react';

const RightSidebarContext = createContext(null);

/**
 * 우측 사이드바 공통 영역 제어 (장바구니, 알림 등)
 * - open(mode): 사이드바 열기 ('cart' | 'notification')
 * - close(): 사이드바 닫기
 */
export const RightSidebarProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState('cart');

  const open = useCallback((sidebarMode = 'cart') => {
    setMode(sidebarMode);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const value = {
    isOpen,
    mode,
    open,
    close,
  };

  return (
    <RightSidebarContext.Provider value={value}>
      {children}
    </RightSidebarContext.Provider>
  );
};

export const useRightSidebar = () => {
  const context = useContext(RightSidebarContext);
  if (!context) {
    throw new Error('useRightSidebar must be used within a RightSidebarProvider');
  }
  return context;
};

export default RightSidebarContext;
